import { Component, Input, OnInit } from '@angular/core';
import { SaveQuoteModalTriggerService } from '../saved-quotes/services/save-quote-modal-trigger.service';
import { ENROLLMENT_FLOW } from '../../form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/enrollment-flow.enum';
import { SaveQuoteModalArgs } from '../saved-quotes/interfaces/save-quote-data.interface';

@Component({
    selector: 'app-save-quote-button',
    templateUrl: './save-quote-button.component.html',
    styleUrls: ['./save-quote-button.component.scss'],
    standalone: false
})
export class SaveQuoteButtonComponent implements OnInit {
  
  @Input() saveQuoteText: string;
  @Input() returnUrl: string;
  @Input() enrollmentFlow: ENROLLMENT_FLOW;
  @Input() quoteButtonPage: string;

  constructor(
    private saveQuoteModalTriggerService: SaveQuoteModalTriggerService
  ) { }

  ngOnInit() {
   }

  async triggerSaveQuoteModal() {
    const modalArgs: SaveQuoteModalArgs = {
      urls: {
        returnUrl: this.returnUrl
      },
      enrollmentFlow: this.enrollmentFlow
    }
    this.saveQuoteModalTriggerService.openSaveQuoteModal({
      modalArgs: modalArgs,
      resumptionLandingPage: this.quoteButtonPage
    });
  }
}
